// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"696416ce","383":"76662725","684":"e1a8d8de","903":"8861fcef"}[chunkId] + ".chunk.css";
};